import { Head } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';

interface Movement {
  product_id: number;
  product: string;
  format: string;
  direction: 'up' | 'down';
  pct: number;
  old_price: number;
  new_price: number;
}

interface Props {
  reportedOn: string | null;
  threshold: number;
  items: Movement[];
}

const money = (n: number) =>
  new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', minimumFractionDigits: 0 }).format(n);

export default function Movimientos({ reportedOn, threshold, items }: Props) {
  return (
    <MainLayout>
      <Head>
        <title>Movimientos de precios | Abasto Virtual</title>
        <meta name="robots" content="noindex,nofollow" />
      </Head>

      <div className="mx-auto max-w-3xl px-4 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Movimientos de precios</h1>
          <p className="mt-1 text-gray-500">
            {reportedOn
              ? `Cambios de ${threshold}% o más — ${reportedOn}`
              : `Cambios de ${threshold}% o más`}
          </p>
        </div>

        {items.length === 0 ? (
          <div className="rounded-xl border border-gray-200 bg-white p-8 text-center text-gray-500">
            Todavía no hay movimientos registrados. Cuando haya cambios significativos, los vas a ver acá.
          </div>
        ) : (
          <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
            <ul className="divide-y divide-gray-100">
              {items.map(m => {
                const up = m.direction === 'up';
                return (
                  <li key={m.product_id} className="flex items-center justify-between gap-4 px-5 py-4">
                    <div className="min-w-0">
                      <p className="truncate font-medium text-gray-900">{m.product}</p>
                      <p className="truncate text-sm text-gray-500">
                        {m.format} · {money(m.old_price)} → {money(m.new_price)}
                      </p>
                    </div>
                    <span
                      className={`inline-flex shrink-0 items-center gap-1 rounded-full px-3 py-1 text-sm font-semibold ${
                        up ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'
                      }`}
                    >
                      {up ? '▲' : '▼'} {up ? '+' : ''}{m.pct}%
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </MainLayout>
  );
}
